import CandidatesApi from '../../api/CandidatesApi'
import { ExpiredSessionException } from '../../api/exceptions'
import { handleExpiredAuthState } from './authActions'

export const requestUpdateCandidateList = (deleted, params) => async dispatch => {

  const api = new CandidatesApi();

  await api.list(deleted, params)
    .then(response => {
      let data, total
      if ('data' in response) {
        data = response.data
        total = response.total
      } else {
        data = response
        total = data.length
      }

      dispatch({
        type: 'candidatesList/updateList',
        payload: {
          totalRecords: total,
          records: data
        }
      })
    })
    .catch(error => {
      if (error instanceof ExpiredSessionException) {
        dispatch(handleExpiredAuthState());
      }

      console.log(error);
  })
}

export const setPage = (page) => {
  return (dispatch) => {
    dispatch({
      type: 'candidatesList/setPage',
      page
    })
  }
}

export const setSizePerPage = (sizePerPage) => {
  return (dispatch) => {
    dispatch({
      type: 'candidatesList/setSizePerPage',
      payload: {
        sizePerPage,
        page: 1
      }
    })
  }
}

export const setFilters = (filter) => {
  return (dispatch) => {
    dispatch({
      type: 'candidatesList/setFilters',
      payload: filter
    })
  }
}

export const setListDeleted = (value) => {
  return (dispatch) => {
    dispatch({
      type: 'candidatesList/setListDeleted',
      payload: !!JSON.parse(value)
    })
  }
}

export const deleteFromList = (slug) => {
  return (dispatch) => {
    dispatch({
      type: 'candidatesList/delete',
      slug
    })
  }
}